import {
  GET_ADMIN_CLIENTS_DATA,
  LOADING_ADMIN_CLIENTS_DATA,
  PAGINATION_CLIENTS_DATA,
  SEARCH_CLIENTS_DATA,
  GET_OWNER_STATS,
  GET_OWNER_STATS_SUCCESS,
  GET_OWNER_STATS_FAILURE,
} from "store/actions/admin/clients";
export default function clients(state = null, action) {
  if (state == null) {
    return {
      searchedClients: [],
      clients: [],
      currentPage: 1,
      totalItem: 0,
      isLoadingClients: false,
      loggedInUser: {},
      selectedClient: {},
      selectedOwnerStats: null,
      isLoadingOwnerStats: false,
    };
  }
  switch (action.type) {
    case GET_ADMIN_CLIENTS_DATA:
      return {
        ...state,
        clients: action.payload,
        searchedClients: action.payload,
      };
    case PAGINATION_CLIENTS_DATA:
      return {
        ...state,
        currentPage: action.payload,
      };
    case SEARCH_CLIENTS_DATA:
      return {
        ...state,
        currentPage: 1,
        clients: action.payload,
      };
    case LOADING_ADMIN_CLIENTS_DATA:
      return {
        ...state,
        isLoadingAdminClients: action.payload,
      };
    case GET_OWNER_STATS:
      return {
        ...state,
        isLoadingOwnerStats: true,
        selectedOwnerStats: null,
      };
    case GET_OWNER_STATS_SUCCESS:
      return {
        ...state,
        isLoadingOwnerStats: false,
        selectedOwnerStats: action.payload,
      };
    case GET_OWNER_STATS_FAILURE:
      return {
        ...state,
        isLoadingOwnerStats: false,
        selectedOwnerStats: null,
      };
    default:
      return state;
  }
}
